var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"infinite-scroll",class:_vm.inner_class,attrs:{"name":_vm.name}},[_vm._t("grid-container"),_c('spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.fetching),expression:"fetching"}],staticClass:"mgt20",attrs:{"border":false}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }